import { commsManager } from "appworks/server/comms-manager";
import { Contract } from "appworks/utils/contracts/contract";
import { gamevyModel } from "gamevy/gamevy-model";
import { BalanceRequestPayload } from "gamevy/integration/schema/balance-request-payload";

export function BalanceGetCommand(): Contract<void> {
    if (gamevyModel.sid !== gamevyModel.guestSID) {
        const payload = new BalanceRequestPayload();
        return commsManager.request(payload);
    } else {
        return Contract.empty();
    }
}
